import React, {FunctionComponent} from 'react';
import './CartItemShort.less';
import {CartItemName} from 'elements/cart-item-name/CartItemName';
import {CartItemPrice} from 'elements/cart-item-price/CartItemPrice';

interface CartItemShortProps {
	name: string,
	price: number
}

export const CartItemShort: FunctionComponent<CartItemShortProps> = ({name, price}) => {
	return (
		<div className="cart-item-short">
      <span className="cart-item-short__name">
        <CartItemName name={name}/>
      </span>
			<span className="cart-item-short__price">
        <CartItemPrice price={price}/>
      </span>
		</div>
	);
};
